/* Nordic Floor — m²-kalkulator (Fase B).
   Regnelogikken er identisk med sections/nf-kvadratkalkulator.liquid;
   kun presentasjonen (tekstformatet fra produktside-utkastet) er endret. */
(function () {
  'use strict';

  /* Areal fra tastaturet til et tall — normalisering, ikke regnelogikk.
     =======================================================================
     Feltet var `type="number"`. Da bestemmer nettleseren selv hva som er
     et gyldig tall, og den forkaster tegn den ikke godtar UTEN å si fra:
     «23,5» ble til value «235». Kalkulatoren regnet videre på 235 m² og
     ga 188 pakker / 131 788 kr i stedet for 19 / 13 319 — tigangen for
     mye, uten noe på skjermen som avslørte det.

     Målt i både nb-NO og en-US: feilen er ikke lokalitetsavhengig, og
     komma er det norske tastaturet gir.

     Feltet er nå `type="text" inputmode="decimal"` — da kommer strengen
     urørt hit, og vi tolker den selv:

       «23,5»      → 23.5    komma er norsk desimaltegn
       «23.5»      → 23.5    punktum godtas også
       «1 234,5»   → 1234.5  mellomrom og hardt mellomrom er tusenskille
       «23,»       → 23      halvskrevet tall, ikke en feil
       «,5»        → 0.5
       «23,5,1»    → NaN     to skilletegn er tvetydig
       «1.234,5»   → NaN     samme; punktum som tusenskille er ikke entydig
       «23 m2»     → NaN     bokstaver forkastes, ikke strippes
       «»          → NaN

     NaN og alt ≤ 0 stoppes av vakten i compute(), som før. Regnestykket
     nedenfor er uendret.

     SAMME FUNKSJON finnes i assets/nf-seriekalkulator.js. Endres reglene
     her, må de endres der — test-desimal.js kjører begge mot samme
     fasitliste, så avvik gir utslag. */
  function lesAreal(raa) {
    if (typeof raa !== 'string') return NaN;
    /* Alle former for mellomrom bort: vanlig, hardt (U+00A0), tynt
       (U+2009) og smalt hardt (U+202F). Alle brukes som tusenskille. */
    var s = raa.replace(/[\s   ]/g, '');
    if (s === '') return NaN;
    s = s.replace(/,/g, '.');
    if (s.slice(-1) === '.') s = s.slice(0, -1);   // «23,» mens man skriver
    if (s === '') return NaN;
    /* Ett skilletegn, bare siffer ellers. Ikke minus: negativt areal
       finnes ikke, og «-» skal avvises her og ikke bli 0 lenger nede. */
    if (!/^\d*\.?\d+$/.test(s)) return NaN;
    return parseFloat(s);
  }

  /* Eksponert for regresjonsriggen. Ikke ment for annen bruk. */
  window.nfLesAreal = lesAreal;

  function init(root) {
    if (root.dataset.nfInit) return;

    var sjekk = function (name) { return root.querySelector('[data-nf="' + name + '"]'); };
    if (!sjekk('area') || !sjekk('svinn') || !sjekk('detail') || !sjekk('buy')) return;
    root.dataset.nfInit = '1';

    var cfg = {
      variantId: parseInt(root.dataset.variantId, 10),
      available: root.dataset.available === 'true',
      priceCents: parseInt(root.dataset.priceCents, 10),
      m2PerPack: parseFloat(root.dataset.m2PerPack),
      pattern: root.dataset.pattern,
      cartUrl: root.dataset.cartUrl || '/cart',
      redirect: root.dataset.redirect === 'true',
      /* VAKT MOT NULLPRISET TILLEGGSVALG, andre lag.
         Liquid nuller variant-id-en når prisen mangler eller er 0, så
         upsellet ikke rendres (se snippets/nf-kalkulator.liquid). Her
         nulles den én gang til, ut fra prisen som faktisk kom med i
         markupen. Det er billig, og det betyr at ingen fremtidig
         markupendring kan gi et kjøpbart tilleggsvalg til 0 kr uten at
         begge lagene svikter samtidig. */
      underlayVariantId: (parseInt(root.dataset.underlayPriceCents, 10) || 0) > 0
        ? (parseInt(root.dataset.underlayVariantId, 10) || 0)
        : 0,
      underlayPriceCents: parseInt(root.dataset.underlayPriceCents, 10) || 0,
      underlayM2PerRoll: parseFloat(root.dataset.underlayM2PerRoll) || 10,
      /* Krysset (3. oktober 2026): samme andre lag som underlaget, og et
         delingstall under 1 gir heller ikke noe valg. */
      crossVariantId: (parseInt(root.dataset.crossPriceCents, 10) || 0) > 0 &&
        (parseInt(root.dataset.crossPacksPer, 10) || 0) >= 1
        ? (parseInt(root.dataset.crossVariantId, 10) || 0)
        : 0,
      crossPriceCents: parseInt(root.dataset.crossPriceCents, 10) || 0,
      crossPacksPer: parseInt(root.dataset.crossPacksPer, 10) || 0
    };

    var el = function (name) { return root.querySelector('[data-nf="' + name + '"]'); };
    var areaInput = el('area');
    var svinnSelect = el('svinn');
    var underlayCheck = el('underlay-check');
    /* Rullelinjas starttekst («Antall ruller regnes ut automatisk.»)
       huskes, saa den kan settes tilbake naar arealet toemmes. Til
       27. september ble «3 ruller — 2 025 kr» staaende fra forrige
       verdi (Chromes gjennomgang, punkt 27). */
    var underlayDetail = el('underlay-detail');
    var underlayDetailStart = underlayDetail ? underlayDetail.textContent : '';
    var crossCheck = el('cross-check');
    var crossDetail = el('cross-detail');
    var crossDetailStart = crossDetail ? crossDetail.textContent : '';

    var ceil = function (v) { return Math.ceil(v - 1e-9); };
    var kr = function (v) {
      var d = v % 1 ? 2 : 0;
      return v.toLocaleString('nb-NO', { minimumFractionDigits: d, maximumFractionDigits: d }) + ' kr';
    };
    var komma = function (s) { return s.replace('.', ','); };

    /* Standard svinn ut fra mønstertype. Samme regel står i
       snippets/nf-kalkulator.liquid, som setter «selected» på riktig valg
       og skriver begrunnelsen under feltet — så verdien er riktig også før
       dette skriptet rekker å kjøre. Endres regelen her, må den endres der. */
    var defaultSvinn =
      cfg.pattern === 'fiskebein' || cfg.pattern === 'chevron' ? '0.12' : '0.07';
    svinnSelect.value = defaultSvinn;

    function compute() {
      var area = lesAreal(areaInput.value);
      if (!(area > 0)) return null;
      var svinn = parseFloat(svinnSelect.value) || 0;
      var gross = area * (1 + svinn);
      var packs = Math.max(1, ceil(gross / cfg.m2PerPack));
      var boughtM2 = packs * cfg.m2PerPack;
      /* Rullene deles paa `area`, ikke `gross`: underlag legges kant i
         kant og trenger ikke svinn. Med `gross` fikk en Herringbone-kunde
         med 23 m² fire ruller der tre dekker (25,76 / 8,5 mot 23 / 8,5). */
      var rolls = cfg.underlayVariantId ? ceil(area / cfg.underlayM2PerRoll) : 0;
      var withUnderlay = !!(underlayCheck && underlayCheck.checked);
      /* Krysset: én pakke per crossPacksPer pakker gulv, rundet opp.
         Pakkene gulv er de over, med svinn; selve pakkeregnestykket er
         uendret. */
      var crossPacks = cfg.crossVariantId ? ceil(packs / cfg.crossPacksPer) : 0;
      var withCross = !!(crossCheck && crossCheck.checked);
      var totalCents =
        packs * cfg.priceCents + (withUnderlay ? rolls * cfg.underlayPriceCents : 0) +
        (withCross ? crossPacks * cfg.crossPriceCents : 0);
      return {
        /* `gross` var regnet ut men aldri returnert. Den er arealet med
           svinn, FØR opprunding til hele pakker — altså det tallet
           detaljlinjen skal kalle «inkl. svinn». Regnestykket er uendret;
           verdien var der fra før. */
        area: area, svinn: svinn, gross: gross, packs: packs, boughtM2: boughtM2,
        leftover: boughtM2 - area, rolls: rolls,
        withUnderlay: withUnderlay, crossPacks: crossPacks, withCross: withCross,
        totalCents: totalCents
      };
    }

    /* AREALFEILEN SIES HOEYT.

       Foer 26. september sa den ingenting: compute() ga null, render()
       skjulte resultatet og deaktiverte kjoepsknappen, og stoppet der.
       Maalt i nettleser: «0» og «abc» i feltet ga tom feilmelding, skjult
       resultat og en knapp som ble disabled uten et ord. Disabled knapper
       er ikke fokuserbare, saa en tastaturbruker tabber forbi og finner
       verken knapp eller forklaring. WCAG 3.3.1.

       Skillet mellom «ugyldig» og «halvferdig» er poenget. lesAreal
       avviser «23,» med vilje, fordi det er det man har skrevet halvveis
       inn i «23,5». Et tall som IKKE kan bli gyldig ved neste tast — 0
       eller et negativt — meldes med én gang. Noe som fortsatt kan bli
       gyldig, meldes naar brukeren forlater feltet. Ellers ville feltet
       ropt paa hver tast. */
    function arealfeil(raa, vedForlatt) {
      var t = String(raa || '').trim();
      if (t === '') return null;
      var v = lesAreal(t);
      if (isNaN(v)) {
        return vedForlatt ? 'Skriv arealet i m², for eksempel 23 eller 23,5.' : null;
      }
      if (v <= 0) return 'Arealet må være større enn 0 m².';
      return null;
    }

    var ansaTimer = null;
    function ansa(tekst) {
      var a = el('ansa');
      if (!a) return;
      if (ansaTimer) clearTimeout(ansaTimer);
      if (!tekst) { a.textContent = ''; return; }
      ansaTimer = setTimeout(function () { a.textContent = tekst; }, 500);
    }

    function visArealfeil(vedForlatt) {
      var m = arealfeil(areaInput.value, vedForlatt);
      if (m) {
        showError(m);
        areaInput.setAttribute('aria-invalid', 'true');
      } else {
        areaInput.removeAttribute('aria-invalid');
      }
      return !!m;
    }

    function render() {
      var r = compute();
      var result = el('result');
      var buy = el('buy');
      el('error').hidden = true;
      el('success').hidden = true;
      if (!r) {
        result.hidden = true;
        buy.disabled = true;
        buy.textContent = 'Legg i handlekurven';
        if (underlayDetail) underlayDetail.textContent = underlayDetailStart;
        if (crossDetail) crossDetail.textContent = crossDetailStart;
        visArealfeil(false);
        ansa(null);
        return;
      }
      areaInput.removeAttribute('aria-invalid');
      el('packs').textContent = r.packs + (r.packs === 1 ? ' pakke' : ' pakker');
      /* To linjer, fordi det er to tall med ulik betydning.
         Den gamle teksten sa «26,64 m² inkl. 12 % svinn — du trenger
         23,0 m²» og merket dermed OPPRUNDINGEN som svinn. 23,0 + 12 % er
         25,76; de 26,64 er det 19 pakker dekker etter at vi runder opp
         til hele pakker. Reelt ble påslaget 15,8 %, ikke 12.

         Begge tallene kommer fra samme utregning som pakkeantallet —
         `gross` og `boughtM2` i compute(). Ingen nye konstanter, ingen
         endring i regnelogikken. */
      el('detail').textContent =
        'Du trenger ' + komma(r.gross.toFixed(2)) + ' m² inkl. ' +
        Math.round(r.svinn * 100) + ' % svinn\n' +
        r.packs + (r.packs === 1 ? ' pakke dekker ' : ' pakker dekker ') +
        komma(r.boughtM2.toFixed(2)) + ' m²';
      var suffix = '';
      if (r.withUnderlay && r.rolls > 0) {
        suffix = cfg.underlayPriceCents > 0
          ? ' inkl. ' + r.rolls + (r.rolls === 1 ? ' rull' : ' ruller') + ' underlag'
          : ' + ' + r.rolls + (r.rolls === 1 ? ' rull' : ' ruller') + ' underlag';
      }
      var kryssTekst = r.withCross && r.crossPacks > 0
        ? r.crossPacks + (r.crossPacks === 1 ? ' pakke' : ' pakker') + ' kryss'
        : '';
      if (kryssTekst) suffix += (suffix ? ' og ' : ' inkl. ') + kryssTekst;
      el('total').innerHTML = 'Totalt <i>' + kr(r.totalCents / 100) + '</i>' + suffix;
      if (crossDetail && cfg.crossPriceCents > 0) {
        crossDetail.textContent =
          r.crossPacks + (r.crossPacks === 1 ? ' pakke — ' : ' pakker — ') + kr((r.crossPacks * cfg.crossPriceCents) / 100);
      }
      var detail = el('underlay-detail');
      if (detail && cfg.underlayPriceCents > 0) {
        detail.textContent =
          r.rolls + (r.rolls === 1 ? ' rull — ' : ' ruller — ') + kr((r.rolls * cfg.underlayPriceCents) / 100);
      }
      result.hidden = false;
      buy.disabled = !cfg.available;
      /* Med underlaget krysset av sier knappen ogsaa rullene — det er det
         den legger i kurven. */
      buy.textContent = cfg.available
        ? 'Legg i handlekurven — ' + r.packs + (r.packs === 1 ? ' pakke' : ' pakker') +
          (r.withUnderlay && r.rolls > 0 ? ' + ' + r.rolls + (r.rolls === 1 ? ' rull' : ' ruller') : '') +
          (kryssTekst ? ' + ' + kryssTekst : '')
        : 'Utsolgt';
      /* Én linje, i den rekkefoelgen kunden spoer: hvor mange, hvor mye,
         hva koster det. */
      ansa(r.packs + (r.packs === 1 ? ' pakke, ' : ' pakker, ') +
        komma(r.boughtM2.toFixed(2)) + ' m², totalt ' + kr(r.totalCents / 100) +
        (r.withUnderlay && r.rolls > 0 ? ' inkludert ' + r.rolls + (r.rolls === 1 ? ' rull' : ' ruller') + ' underlag' : '') +
        (kryssTekst ? (r.withUnderlay && r.rolls > 0 ? ' og ' : ' inkludert ') + kryssTekst : ''));
    }
    areaInput.addEventListener('input', render);
    /* Ved blur meldes ogsaa det som fortsatt kunne blitt gyldig. Det er
       her «abc» og «23,» faar sitt svar. */
    areaInput.addEventListener('blur', function () { visArealfeil(true); });
    svinnSelect.addEventListener('change', render);
    if (underlayCheck) underlayCheck.addEventListener('change', render);
    if (crossCheck) crossCheck.addEventListener('change', render);

    function showError(msg) {
      var e = el('error');
      e.textContent = msg;
      e.hidden = false;
    }
    function showSuccess(msg) {
      var s = el('success');
      s.textContent = msg;
      s.hidden = false;
    }

    function addToCart(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || 'Kunne ikke legge i handlekurven.');
          });
        }
        return res.json();
      });
    }

    el('buy').addEventListener('click', function () {
      var r = compute();
      if (!r) return;
      var btn = this;
      btn.disabled = true;
      /* «Per pakke» FOELGER LINJA INN I KASSEN.

         Kassen viser bare navn, antall og pris. En kunde som har
         bestilt 20 pakker ser ikke hvor mye gulv det er. En offentlig
         line item property gjoer det — den rendres i kassens
         ordresammendrag og i ordrebekreftelsen.

         VERDIEN ER PER PAKKE, IKKE TOTALEN, og det er hele poenget.
         En property er en tekststreng som frys ved innlegging: Dawn
         poster antallsendringer til /cart/change.js UTEN properties, saa
         en total ville staatt igjen med det gamle antallet ved siden av
         det nye. «1,296 m² per pakke» avhenger ikke av antallet og kan
         derfor ikke bli gammel. Totalen regnes i stedet i Liquid paa
         varelinja i kurven, der den rendres paa nytt ved hvert klikk.

         Maalt 26. september: property-en overlever pluss-knappen med
         samme linjenoekkel, og linjer MED og UTEN property slaas ikke
         sammen. Alle innlegg gaar gjennom denne knappen, saa linjene er
         konsistente og slaas sammen med hverandre.

         NAVNET ER KOBLET TIL TEMAET. sections/main-cart-items.liquid
         skjuler noeyaktig denne property-en i handlekurven, som alt har
         en enhetslinje. Endres navnet her, maa det endres der.

         Underlaget faar ingen property: det har ingen metafelter, og
         m²-tallet staar i produkttittelen «(8,5 m²/rull)». */
      var items = [{ id: cfg.variantId, quantity: r.packs,
        properties: { 'Per pakke': komma(String(cfg.m2PerPack)) + ' m²' } }];
      /* Tredje lag: selv om avhukingen fantes og ble krysset av, legges
         underlaget aldri i kurven uten en pris. Kravet staar her, ved
         kjoepet, og ikke bare der knappen rendres. */
      if (r.withUnderlay && r.rolls > 0 &&
          cfg.underlayVariantId && cfg.underlayPriceCents > 0) {
        items.push({ id: cfg.underlayVariantId, quantity: r.rolls });
      }
      /* Krysset: samme tredje lag. Ingen property; antallet står i
         tittelen («50 stk./pakke»). */
      if (r.withCross && r.crossPacks > 0 &&
          cfg.crossVariantId && cfg.crossPriceCents > 0) {
        items.push({ id: cfg.crossVariantId, quantity: r.crossPacks });
      }
      addToCart(items)
        .then(function () {
          if (cfg.redirect) {
            window.location.href = cfg.cartUrl;
          } else {
            showSuccess('Lagt i handlekurven.');
            btn.disabled = false;
          }
        })
        .catch(function (err) {
          showError(err.message);
          btn.disabled = false;
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-nf-kalk]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme-editoren bytter ut seksjonens DOM ved re-render; init på nytt. */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-nf-kalk]').forEach(init);
  });
})();
